import { takeLatest, all, select, put } from 'redux-saga/effects'
import { updates } from 'fn-update'

import { Machine, MatchInit } from '../goose'
import { makeAction } from '../action'
import { urlParam } from '../../util/url'

const NAMESPACE = 'webview'
const ns = (action) => `${NAMESPACE}/${action}`

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Constants
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

const APP_IOS_CONTEXT = 'app-ios'
const APP_ANDROID_CONTEXT = 'app-android'
const MESSENGER_CONTEXT = 'messenger'
const URL_PARAM = 'webview'

const constants = {
  NAMESPACE: NAMESPACE,
  APP_IOS_CONTEXT: APP_IOS_CONTEXT,
  APP_ANDROID_CONTEXT: APP_ANDROID_CONTEXT,
  MESSENGER_CONTEXT: MESSENGER_CONTEXT
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Actions
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

// Sync action types.
const actionTypes = {
  SET_CONTEXT: ns('SET_CONTEXT'),
  CLOSE_WEBVIEW: ns('CLOSE_WEBVIEW'),
}

const actions = {
  closeWebview: () => {
    return makeAction(actionTypes.CLOSE_WEBVIEW)
  }
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Selectors
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

const selectors = {
  getContext: (state) => state[NAMESPACE].context,
  isMessengerContext: (state) => state[NAMESPACE].context == MESSENGER_CONTEXT,
  isAppIOSContext: (state) => state[NAMESPACE].context == APP_IOS_CONTEXT,
  isAppAndroidContext: (state) => state[NAMESPACE].context == APP_ANDROID_CONTEXT,
  isReady: (state) => state[NAMESPACE].ready
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Reducer
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

const reducer = Machine({
  [Machine.INIT]: () => ({
    context: null,
    ready: false
  }),

  [actionTypes.SET_CONTEXT]: ({ context }) => updates({
    context: context,
    ready: true
  }),
})

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Sagas
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

const closingHandlers = {
  [MESSENGER_CONTEXT]: () => {
    const noop = () => {}
    const handler = window.MessengerExtensions
    if (handler) handler.requestCloseBrowser(noop, noop)
  },

  [APP_IOS_CONTEXT]: () => {
    const webkit = window.webkit
    if (!webkit) return
    const handler = webkit.messageHandlers.callbackHandler
    if (handler) handler.postMessage('dismissWebViewController')
  },

  [APP_ANDROID_CONTEXT]: () => {
    const bridge = window.AndroidBridge
    if (bridge && bridge.dismissWebView) bridge.dismissWebView()
  },
}

function* onCloseWebviewRequested() {
  const context = yield select(selectors.getContext)
  if (!context) return
  const handler = closingHandlers[context]
  try {
    if (handler) handler()
  } catch (error) {
    console.log(error)
  }
}

function* onInitialize() {
  // Search for `webview` context in the URL query string.
  let context = yield select(state => {
    const qs = state.router.location.search
    return urlParam(URL_PARAM, qs)
  })
  if (context) {
    window.localStorage.setItem('webviewContext', context)
  } else {
    context = window.localStorage.getItem('webviewContext')
  }
  yield put(makeAction(actionTypes.SET_CONTEXT, { payload: { context } }))
}

const saga = function*(){
  yield all([
    takeLatest(MatchInit(NAMESPACE), onInitialize),
    takeLatest(actionTypes.CLOSE_WEBVIEW, onCloseWebviewRequested),
  ])
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Module exports
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

export default {
  key: NAMESPACE,
  reducer,
  saga,
  constants,
  actions,
  actionTypes,
  selectors,
  dependencies: []
}



// WEBPACK FOOTER //
// ./src/redux/modules/webview.js